module.exports = __webpack_public_path__ + "img/personalizacoes.8be71862.svg";